import Auth from './auth'
import login from './login/login-routing'
import forgrt from './forget/forget-routing'
import register from './register/reg-routing'
import bindMobile from './bindMobile/router'
import changePwd from './changePwd/change-password-routing'


export default [{
    path: '/auth',
    name: 'auth',
    component: Auth,
    children:[
        ...login, 
        ...forgrt,
        ...register,
        ...bindMobile,
        ...changePwd
    ]
},]
